<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
//首页复制折扣按钮
document.addEventListener('click', function(e) {
  if (e.target.closest('.product-copy')) {
    const copyBtn = e.target.closest('.product-copy');
    const discountCodeEl = copyBtn.closest('.product-discount')?.querySelector('.discount-code');

    if (!discountCodeEl) return;

    const code = discountCodeEl.textContent.trim();
    
    const textarea = document.createElement('textarea');
    textarea.value = code;
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999);

    try {
      const successful = document.execCommand('copy');
      alert(successful ? 'Copied: ' + code : 'Copy failed, please copy manually.');
    } catch {
      alert('Copy failed, please copy manually.');
    }

    document.body.removeChild(textarea);
  }
});
// 产品页面复制折扣按钮
function copyDiscountCode() {
  var code = document.getElementById("discountCode").innerText.trim();

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(code)
      .then(function () {
        showCopied();
      })
      .catch(function () {
        fallbackCopy(code);
      });
  } else {
    fallbackCopy(code);
  }
}

function fallbackCopy(text) {
  var tempInput = document.createElement("input");
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  showCopied();
}

function showCopied() {
  var msg = document.getElementById("copyMessage");
  if (msg) {
    msg.style.display = "inline";
  }

  // GA4 事件
  if (typeof gtag === 'function') {
    gtag('event', 'copy_discount_click', {
      event_category: 'outbound',
      event_label: '{{ product.handle }}',
      product_title: '{{ product.title }}',
      page_location: window.location.href,
      transport_type: 'beacon'
    });
    setTimeout(function () {
      if (msg) {
        msg.style.display = "none";
      }
      window.location.href = "{{ product.metafields.custom.url }}";
    }, 1000);
  }
}
 
  //跳转按钮
  document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('amazon-btn');
  if (btn) {
    btn.addEventListener('click', function () {
      // 发送 GA4 点击事件
      if (typeof gtag === 'function') {
        gtag('event', 'amazon_click', {
          event_category: 'outbound',
          event_label: '{{ product.handle }}',
          product_title: '{{ product.title }}',
          page_location: window.location.href,
          transport_type: 'beacon'
        });
      }
    });
  }
});
